module.exports = __webpack_public_path__ + "static/img/hzjz.439c097.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/customers/hzjz.png
// module id = Rt+d
// module chunks = 0